/**
 * mixin 全局的 toast
 */
import Vue from 'vue'
Vue.mixin({
  methods: {
    showToast(text) {
      this.$store.dispatch('UPDATE_TOAST', {
        show: true,
        text: text,
        time: 1000
      })
    },
    switchLoading(loading) {
      window.setTimeout(() => {
        this.$store.commit('UPDATE_LOADING', {
          status: loading.status || false,
          text: loading.text || ''
        })
      }, loading.time)
    }
  }
})



// WEBPACK FOOTER //
// ./src/common/mixins.js